import { render, staticRenderFns } from "./AguinaldoFiniquito.vue?vue&type=template&id=d5456532&scoped=true"
import script from "./AguinaldoFiniquito.vue?vue&type=script&lang=js"
export * from "./AguinaldoFiniquito.vue?vue&type=script&lang=js"
import style0 from "./AguinaldoFiniquito.vue?vue&type=style&index=0&id=d5456532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5456532",
  null
  
)

export default component.exports